import { useState } from 'react';
import CopyIcon from 'assets/copy-icon.svg';
import clipboard from 'clipboard';

import { Tooltip } from 'components/Tooltip';

import classes from './style.module.css';

interface CopyToClipboardIconProps {
  id?: string; // may need unique id's if multiple copy icons are on the same page
  textToCopy: string;
  tooltipClassName?: string;
}

/**
 *  Icon that copies the textToCopy prop to the clipboard when clicked
 * @param textToCopy - The text to copy to the clipboard
 * @returns A copy icon that copies the textToCopy prop to the clipboard when clicked
 */
export const CopyToClipboardIcon: React.FC<CopyToClipboardIconProps> = ({
  id = 'copy-icon-tooltip',
  textToCopy,
  tooltipClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCopyClick = () => {
    clipboard.copy(textToCopy);

    // Show the tooltip for a short duration to indicate that the text has been copied
    setIsOpen(true);
    setTimeout(() => setIsOpen(false), 1000);
  };

  return (

    <span
      role="button"
      tabIndex={0}
      onKeyDown={handleCopyClick}
      data-tooltip-id={id}
      className={classes.copyIconContainer}
      onClick={handleCopyClick}
    >
      <img src={CopyIcon} alt="Copy icon" />
      <Tooltip id={id} className={tooltipClassName} place="top" isOpen={isOpen} content="Copied!" />
    </span>
  );
};
